import { supabase } from "@/lib/supabase";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { Recipe } from "@/features/Recipes-renamed/types";
import { mapDatabaseRecipeToRecipe, type RecipesRowWithRelations } from "@/lib/mapDatabaseRecipeToRecipe";

export function useFavoriteRecipes(): UseQueryResult<Recipe[]> {
    return useQuery({
        queryKey: ["favoriteRecipes"],
        queryFn: async () => {
            const { data, error } = await supabase
                .from("random_favorites")
                .select(
                    `
                        *,
                        recipe_types (*),
                        recipe_categories (*),
                        ingredient_groups (*, ingredients (*))
                    `
                )
                .limit(10);

            if (error || !data) {
                console.error("Error fetching favorite recipes:", error);
                throw error;
            }

            const recipes: Recipe[] = data.map((rows) =>
                mapDatabaseRecipeToRecipe(rows as unknown as RecipesRowWithRelations)
            );

            return recipes;
        }
    });
}
